import React, { useState } from "react";
import { ThemeProvider } from "styled-components";
import { themes } from "./theme";
import { GlobalStyles } from "./global";
import { CursorProvider } from "react-cursor-custom";
import { settings } from "./portfolio";
import { TooltipProvider } from "react-tooltip";
import { LanguageProvider } from "./context/LanguageContext";
import Main from "./containers/Main";
import "./App.css";
import "react-tooltip/dist/react-tooltip.css";

function App() {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");
  const useCursor = settings.useCustomCursor;

  return (
    <LanguageProvider>
      <ThemeProvider theme={themes[theme]}>
        <>
          <GlobalStyles />
          <div>
            {useCursor ? (
              <CursorProvider
                color={themes[theme].secondaryText}
                ringSize={25}
                transitionTime={75}
              >
                <TooltipProvider>
                  <Main theme={themes[theme]} setTheme={setTheme} />
                </TooltipProvider>
              </CursorProvider>
            ) : (
              <Main theme={themes[theme]} setTheme={setTheme} />
            )}
          </div>
        </>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
